import VmpPcRewardEffect from './src/main.vue';

VmpPcRewardEffect.install = function (Vue) {
  Vue.component(VmpPcRewardEffect.name, VmpPcRewardEffect);
};

export default VmpPcRewardEffect;
